import {BasePageRequest} from './BasePageRequest';

export class EmployeeSearchRequest extends BasePageRequest {

    name: string;
    surname: string;
    departmentId: number;
    titleId: number;
    birthDateMin: string;
    birthDateMax: string;
    gender: string;
    active: number;
    isNew:number;

    constructor(pageNumber: any, size: any, sortColumn: any, sortDirection: any) {
        super(pageNumber, size, sortColumn, sortDirection);
        this.active = 1;
        this.isNew = 0;
    }
}
